import { render, staticRenderFns } from "./GamePreviewSettings.vue?vue&type=template&id=6882c8e9&scoped=true&lang=pug&"
import script from "./GamePreviewSettings.vue?vue&type=script&lang=js&"
export * from "./GamePreviewSettings.vue?vue&type=script&lang=js&"
import style0 from "./GamePreviewSettings.vue?vue&type=style&index=0&id=6882c8e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882c8e9",
  null
  
)

export default component.exports